import React from 'react';
import { FormField } from '../../../components';

// Step navigation lives in the ConvertClient page header, top-right.
const AllAboutMe = ({ updateData, data }) => {
    const aboutMe = data.aboutMeDetails || {};

    const handleChange = (e) => {
        const { name, value } = e.target;
        updateData('aboutMeDetails', { [name]: value });
    };

    return (
        <div>
            <h2 className="text-[22px] font-bold text-[#334155] dark:text-gray-200 mb-8">All About Me & Lifestyle</h2>

            <div className="flex flex-col md:flex-row gap-10">

                {/* Left Column - Background & Lifestyle */}
                <div className="flex-1 flex flex-col gap-6">
                    <h3 className="text-[15px] font-semibold text-[#1E293B] dark:text-gray-200">Background & Lifestyle</h3>

                    <FormField 
                        label="Previous Occupation"
                        name="previous_occupation"
                        value={aboutMe.previous_occupation || ''}
                        onChange={handleChange}
                        placeholder="What they did for a living"
                    />
                    
                    <FormField 
                        label="Hobbies & Interests"
                        name="hobbies_interests"
                        type="textarea"
                        rows={2}
                        value={aboutMe.hobbies_interests || ''}
                        onChange={handleChange}
                        placeholder="e.g. Gardening, Reading, Music"
                    />

                    <FormField 
                        label="Important Life Events"
                        name="important_life_events"
                        type="textarea"
                        rows={2}
                        value={aboutMe.important_life_events || ''}
                        onChange={handleChange}
                        placeholder="e.g. Anniversary, Awards, Career milestones"
                    />

                    <FormField 
                        label="Spiritual / Cultural Needs"
                        name="spiritual_cultural_needs"
                        value={aboutMe.spiritual_cultural_needs || ''}
                        onChange={handleChange}
                        placeholder="e.g. Church visits, Halal food"
                    />

                    <FormField 
                        label="Detailed Religious / Cultural Practices"
                        name="religious_cultural_practices_details"
                        type="textarea"
                        rows={2}
                        value={aboutMe.religious_cultural_practices_details || ''}
                        onChange={handleChange}
                        placeholder="Provide more detail on specific needs"
                    />
                </div>

                {/* Vertical Dashed Divider */}
                <div className="hidden md:block w-px border-l-2 border-dashed border-gray-200 dark:border-gray-800"></div>

                {/* Right Column - Daily Routines & Preferences */}
                <div className="flex-1 flex flex-col gap-6">
                    <h3 className="text-[15px] font-semibold text-[#1E293B] dark:text-gray-200">Daily Routines & Preferences</h3>

                    <div className="grid grid-cols-2 gap-5">
                        <FormField 
                            label="Wake up time"
                            name="usual_wake_up_time"
                            type="time" 
                            value={aboutMe.usual_wake_up_time || ''}
                            onChange={handleChange}
                        />
                        <FormField 
                            label="Bed time"
                            name="usual_bed_time"
                            type="time" 
                            value={aboutMe.usual_bed_time || ''}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-5">
                        <FormField 
                            label="Food Likes"
                            name="food_likes"
                            value={aboutMe.food_likes || ''}
                            onChange={handleChange}
                            placeholder="Favorite foods"
                        />
                        <FormField 
                            label="Food Dislikes"
                            name="food_dislikes"
                            value={aboutMe.food_dislikes || ''}
                            onChange={handleChange}
                            placeholder="Foods to avoid"
                        />
                    </div>

                    <FormField 
                        label="Preferred Name/Address"
                        name="preferred_address_name"
                        value={aboutMe.preferred_address_name || ''}
                        onChange={handleChange}
                        placeholder="How they prefer to be addressed?"
                    />

                    <FormField 
                        label="Distress / Anxiety Triggers"
                        name="distress_anxiety_triggers"
                        type="textarea"
                        rows={2}
                        value={aboutMe.distress_anxiety_triggers || ''}
                        onChange={handleChange}
                        placeholder="Things that cause distress"
                    />

                    <FormField 
                        label="Comfort / Calming things"
                        name="comfort_calming_things"
                        type="textarea"
                        rows={2}
                        value={aboutMe.comfort_calming_things || ''}
                        onChange={handleChange}
                        placeholder="Things that provide comfort"
                    />
                </div>

            </div>

        </div>
    );
};

export default AllAboutMe;